import React from 'react';
import styled from 'styled-components';

type Props = {
    children: string,
}

const H4 = (props: Props) => {
    return (
        <H4WithStyled { ...props }>
            { props.children }
        </H4WithStyled>
    );
};

const H4WithStyled = styled.h4`
`

export default H4;